module.exports = __webpack_public_path__ + "media/images/icon__search--rb-gray@3x-e899b08c55530371ccfd304a7e8b9adc.png";